import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

// The match keeps the full text color; the rest is dimmed, so the match stands out
// by contrast (per design) rather than by font weight.
const Match = styled('mark')(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
}));

const Dimmed = styled('span')(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Highlights every case-insensitive occurrence of the typed query inside the label.
export const renderHighlightedLabel = (label: string, query: string): ReactNode => {
  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return label;
  }

  const matcher = new RegExp(`(${escapeRegExp(trimmedQuery)})`, 'ig');
  const segments = label.split(matcher).filter(Boolean);

  return segments.map((segment, index) =>
    segment.toLowerCase() === trimmedQuery.toLowerCase()
      ? <Match key={`${index}-${segment}`}>{segment}</Match>
      : <Dimmed key={`${index}-${segment}`}>{segment}</Dimmed>);
};
